<template>
  <div ref="drops" class="app-drops-view">
    <div
      v-for="item in drops"
      :key="item.id"
      class="img"
      @click="editDrop(item)"
    >
      <img :src="item.url" alt="" />
    </div>
    <!-- <div class="img">
      <img src="./../../assets/images/dashboard/1.jpg" alt="" />
    </div>
    <div class="text-pin">
      <div class="text">
        <span class="mark">
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Harum ipsam
          in obcaecati ex doloribus eos deserunt impedit cupiditate excepturi
          quaerat illo, odio nesciunt ea alias, unde, asperiores facere sint
          quia?
        </span>
      </div>
      <div class="origin">
        <div class="icon">
          <img src="./../../assets/images/dashboard/2.jpg" alt="" />
        </div>
        <div class="title">cnn.com</div>
      </div>
    </div>
    <div class="img">
      <img src="./../../assets/images/dashboard/2.jpg" alt="" />
    </div>
    <div class="img">
      <img src="./../../assets/images/dashboard/3.jpg" alt="" />
    </div>
    <div class="img">
      <img src="./../../assets/images/dashboard/4.jpg" alt="" />
    </div>
    <div class="img">
      <img src="./../../assets/images/dashboard/5.jpeg" alt="" />
    </div>
    <div class="img">
      <img src="./../../assets/images/dashboard/6.png" alt="" />
    </div>
    <div class="img">
      <img src="./../../assets/images/dashboard/7.jpeg" alt="" />
    </div>
    <div class="img">
      <img src="./../../assets/images/dashboard/1.jpg" alt="" />
    </div>
    <div class="img">
      <img src="./../../assets/images/dashboard/2.jpg" alt="" />
    </div>
    <div class="img">
      <img src="./../../assets/images/dashboard/3.jpg" alt="" />
    </div>
    <div class="img">
      <img src="./../../assets/images/dashboard/4.jpg" alt="" />
    </div>
    <div class="img">
      <img src="./../../assets/images/dashboard/5.jpeg" alt="" />
    </div>
    <div class="img">
      <img src="./../../assets/images/dashboard/6.png" alt="" />
    </div>
    <div class="img">
      <img src="./../../assets/images/dashboard/7.jpeg" alt="" />
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Sortable from 'sortablejs';
import { ModalEvents } from 'app/utils/events';

export default {
  name: 'DropsView',
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({ drops: 'drop/drops' }),
  },

  mounted() {
    Sortable.create(this.$refs.drops, {
      sort: true,
      forceFallback: true,
      direction: 'vertical',
      dragoverBubble: true,
    });
  },
  methods: {
    editDrop(item) {
      ModalEvents.emit('editDrop:open', item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/mixins.scss';
.app-drops-view {
  overflow: auto;
  @include scrollbar(4px);
  $gap: 10px;

  column-count: 4;
  column-gap: $gap;

  .img {
    margin-bottom: $gap;
    img {
      width: 100%;
      height: auto;
      border-radius: 8px;
    }
  }

  .text-pin {
    padding: 25px 20px;
    white-space: nowrap;
    page-break-inside: avoid;
    break-inside: avoid-column;
    margin-bottom: 10px;
    .text {
      .mark {
        font-size: 16px;
        // background: #ffa61b;
        color: black;
        padding: 0px;
        line-height: 32px;
        white-space: normal;
        font-family: 'Playfair Display';
      }
    }
    .origin {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin: 16px 0;
      .icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        overflow: hidden;
        display: flex;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .title {
        margin-left: 7px;
        font-size: 14px;
        margin-top: -2px;
        color: #717171;
      }
    }
  }

  .sortable-ghost {
    background: #f2f2f2;
    border-radius: 8px;
    & * {
      opacity: 0;
    }
  }

  .sortable-ghost-tag {
    opacity: 0;
  }
}
</style>
